<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="25 40 53 40" style="enable-background:new 25 40 53 40;" xml:space="preserve"
         :style="`fill: ${iconColor};`"
         :width="width"
         :height="height">
	<g>
		<path d="M54.4,78.4h-4.8L32.7,51.3l-0.1,0v27.1h-4.8V43.3h4.8l16.9,27.1l0.1,0V43.3h4.8V78.4z M58.3,51c0-2.4,0.8-4.3,2.3-5.8
			c1.5-1.5,3.5-2.3,6.1-2.3c2.5,0,4.6,0.8,6.1,2.3c1.5,1.5,2.3,3.4,2.3,5.8v2.8c0,2.4-0.8,4.3-2.3,5.8s-3.5,2.2-6,2.2
			c-2.5,0-4.6-0.7-6.1-2.2c-1.5-1.5-2.3-3.4-2.3-5.8V51z M72.2,71.1H60.4v-3.7h11.8V71.1z M62.5,53.8c0,1.4,0.4,2.5,1.1,3.4
			c0.7,0.8,1.8,1.3,3.1,1.3c1.3,0,2.4-0.4,3.1-1.3c0.7-0.9,1.1-2,1.1-3.4V51c0-1.4-0.4-2.5-1.1-3.3c-0.7-0.9-1.8-1.3-3.1-1.3
			s-2.4,0.4-3.1,1.3c-0.7,0.9-1.1,2-1.1,3.3V53.8z"/>
	</g>
</svg>
    <!--<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"-->
    <!--viewBox="0 0 21 21" style="enable-background:new 0 0 21 21;" xml:space="preserve"-->
    <!--:style="`fill: ${iconColor};`"-->
    <!--:width="width"-->
    <!--:height="height">-->
    <!--<title>search</title>-->
    <!--<desc>Created with Sketch.</desc>-->
    <!--<path d="M10.5,0C4.7,0,0,4.7,0,10.5S4.7,21,10.5,21S21,16.3,21,10.5S16.3,0,10.5,0z"/>-->
    <!--<g>-->
    <!--<path class="st0" d="M4.8,15.1V6h1.3l2.4,4.5c0.5,1.1,1,2.1,1.4,3l0,0c-0.1-1.3-0.1-2.3-0.1-3.8V6H11v9.1H9.7l-2.4-4.5-->
    <!--c-0.5-1-1-2.1-1.4-3.1l0,0c0.1,1.2,0.1,2.2,0.1,3.8v3.8H4.8z M16.2,8.6c0,1.7-1.1,2.5-2.2,2.5c-1.2,0-2.2-0.9-2.2-2.4-->
    <!--c0-1.6,1-2.5,2.2-2.5C15.3,6.2,16.2,7.1,16.2,8.6z M12.1,12.3v-0.7h3.7v0.7H12.1z M12.8,8.6c0,1,0.5,1.7,1.2,1.7-->
    <!--c0.7,0,1.2-0.7,1.2-1.7c0-0.8-0.3-1.7-1.2-1.7C13.1,6.9,12.8,7.8,12.8,8.6z"/>-->
    <!--</g>-->
    <!--</svg>-->
</template>

<script>
    export default {
        name: "RegistrationNumberIcon",
        props: {
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>
    .st0 {
        fill: #FFFFFF;
    }
</style>
